import React from 'react';
import { IconButton, Tooltip } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import PropTypes from 'prop-types';

const ActionsCell = (props) => {
  const { rowData, column } = props;
  const { t, onEditCell, customActionsCell, actionsDisabledByConditional } =
    column;

  if (actionsDisabledByConditional) {
    actionsDisabledByConditional(props, customActionsCell);
  }

  return (
    <>
      <>
        {onEditCell && (
          <Tooltip
            className="BaseTable__row-cell-text"
            title={t('general.tables.change_registry')}
          >
            <IconButton
              disabled={false}
              aria-label="edit-button"
              onClick={(evt) => onEditCell(evt, { ...rowData })}
            >
              <EditIcon />
            </IconButton>
          </Tooltip>
        )}
        {customActionsCell.length ? (
          <>
            {customActionsCell.map((action) => {
              return !action.hidden ? (
                <Tooltip key={action.name} title={action.tooltip}>
                  <IconButton
                    disabled={false}
                    onClick={(evt) => action.callback(evt, { ...rowData })}
                  >
                    {action.icon}
                  </IconButton>
                </Tooltip>
              ) : null;
            })}
          </>
        ) : null}
      </>
    </>
  );
};

ActionsCell.propTypes = {
  rowData: PropTypes.shape(PropTypes.shape).isRequired,
  column: PropTypes.shape({
    selectedRows: PropTypes.arrayOf(PropTypes.number),
    onSelect: PropTypes.func,
    actionsDisabledByConditional: PropTypes.func,
    t: PropTypes.func.isRequired,
    onEditCell: PropTypes.func.isRequired,
    customActionsCell: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string.isRequired,
        icon: PropTypes.element.isRequired,
        tooltip: PropTypes.string.isRequired,
        callback: PropTypes.func.isRequired,
      })
    ),
  }).isRequired,
};

export default ActionsCell;
